export const types = {
  RATING_CONFIRM_REQUEST: 'RATINGS/RATING_CONFIRM_REQUEST',
  RATING_CONFIRM_SUCCESS: 'RATINGS/RATING_CONFIRM_SUCCESS',
  RATING_CONFIRM_FAILURE: 'RATINGS/RATING_CONFIRM_FAILURE',
  RATING_STARS_REQUEST: 'RATINGS/RATING_STARS_REQUEST',
  RATING_STARS_SUCCESS: 'RATINGS/RATING_STARS_SUCCESS',
  RATING_STARS_FAILURE: 'RATINGS/RATING_STARS_FAILURE',
  RATING_FEEDBACK_REQUEST: 'RATINGS/RATING_FEEDBACK_REQUEST',
  RATING_FEEDBACK_SUCCESS: 'RATINGS/RATING_FEEDBACK_SUCCESS',
  RATING_FEEDBACK_FAILURE: 'RATINGS/RATING_FEEDBACK_FAILURE',
  RATING_SHOW_MODAL: 'RATINGS/RATING_SHOW_MODAL',
  RATING_CLOSE_MODAL: 'RATINGS/RATING_CLOSE_MODAL',
  RATING_TIE_RATINGS_REQUEST: 'RATINGS/RATING_TIE_RATINGS_REQUEST',
  RATING_TIE_RATINGS_SUCCESS: 'RATINGS/RATING_TIE_RATINGS_SUCCESS',
  RATING_TIE_RATINGS_FAILURE: 'RATINGS/RATING_TIE_RATINGS_FAILURE',
};

export const initialState = {
  error: null,
  isLoading: false,
  hasConfirmed: false,
  ratingUuid: null,
  ratingType: null,
  stars: null,
  feedbackModal: {
    isOpen: false,
    helpful: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.RATING_CONFIRM_REQUEST:
      return { ...state, isLoading: true, hasConfirmed: false, error: null };
    case types.RATING_CONFIRM_SUCCESS: {
      return { ...state, isLoading: false, hasConfirmed: true, error: null };
    }
    case types.RATING_CONFIRM_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasConfirmed: false,
        error: action.error,
      };
    case types.RATING_STARS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.RATING_STARS_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case types.RATING_STARS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.RATING_FEEDBACK_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.RATING_FEEDBACK_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case types.RATING_FEEDBACK_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.RATING_SHOW_MODAL:
      return {
        ...state,
        feedbackModal: { isOpen: true, helpful: action.helpful },
      };
    case types.RATING_CLOSE_MODAL:
      return { ...state, feedbackModal: { isOpen: false, helpful: null } };
    case types.RATING_TIE_RATINGS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.RATING_TIE_RATINGS_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case types.RATING_TIE_RATINGS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};

export const actions = {
  confirmRating: (ratingUuid, helpful, ratingType) => ({
    type: types.RATING_CONFIRM_REQUEST,
    ratingUuid,
    helpful,
    ratingType,
  }),
  postRating: (ratingUuid, helpful, ratingType, stars) => ({
    type: types.RATING_STARS_REQUEST,
    ratingUuid,
    helpful,
    ratingType,
    stars,
  }),
  postFeedback: (
    ratingUuid,
    helpful,
    ratingType,
    reasons,
    likedReviewers,
    dislikedReviewers,
    comments
  ) => ({
    type: types.RATING_FEEDBACK_REQUEST,
    ratingUuid,
    helpful,
    ratingType,
    reasons,
    likedReviewers,
    dislikedReviewers,
    comments,
  }),
  showFeedbackModal: (helpful) => ({
    type: types.RATING_SHOW_MODAL,
    helpful,
  }),
  closeFeedbackModal: () => ({
    type: types.RATING_CLOSE_MODAL,
  }),
  tieUserToUnauthedRatings: () => ({
    type: types.RATING_TIE_RATINGS_REQUEST,
  }),
};

export const selectors = {
  feedbackThanksModal: (state) => {
    return state.ratings['feedbackModal'];
  },
};
